"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApi = useApi;
const react_1 = require("react");
const context_1 = require("./context");
function useApi() {
    return (0, react_1.useContext)(context_1.ApiContext);
}
//# sourceMappingURL=hook.js.map